import * as React from 'react';
import * as styles from './TourWidget.css';

interface ITourWidgetProps {
  url: string;
}

export const TourWidget: React.FC<ITourWidgetProps> = ({ url }) => {
  return (
    <iframe
      className={styles['iframe']}
      width="100%"
      height="100%"
      allowFullScreen
      sandbox="allow-scripts allow-same-origin"
      src={url}
    />
  );
};
